import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate, useParams } from "react-router-dom";
import { get } from "../config/api";
import LandingConnector from "../Landing/Connector/LandingConnector";
import MachineLayout from "../Layout/MachineLayout";
import Page from "../Generic/Page";
import Loader from "../Generic/Loader";

/**
 * Validates machine membership and provides MachineLayout. Auth is enforced by AuthenticatedRoute.
 */
const MachineRoute = (props) => {
	const { machineId } = useParams();
	const navigate = useNavigate();
	const [error, setError] = useState(false);

	async function getMachines() {
		const response = await get({ url: "/v1/dashboard/restaurant/all" });
		const { data, error: apiError } = response;
		if (data) {
			const machineData = data.find((item) => item._id === machineId);
			if (!machineData) {
				navigate("/404", { replace: true });
				return;
			}
			props.setMachineID(machineData);
			setError(false);
		}
		if (apiError) {
			setError(true);
		}
	}

	useEffect(() => {
		getMachines();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [machineId]);

	if (props.machineID !== "") {
		return (
			<MachineLayout>
				<Outlet />
			</MachineLayout>
		);
	}

	if (error) {
		return <Navigate to={"/404"} replace />;
	}

	return (
		<Page>
			<Loader />
		</Page>
	);
};

export default LandingConnector(MachineRoute);
